import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, AbstractControlDirective} from '@angular/forms';


@Component({
  selector: 'is-form-error',
  standalone:false,
  template: `
      <div style="font-size: 0.7rem" class="help-block errors text-danger animated shake" *ngIf="shouldShowErrors()"> {{getError()}}</div>
  `,
  styles: []
})
export class FormErrorComponent implements OnInit {

  static readonly errorMessages = {
    required: (params:any) => '##FIELD## is required *',
    minlength: (params:any) => '##FIELD## should be minimum ' + params.requiredLength + ' characters',
    maxlength: (params:any) => '##FIELD## should not be greater than ' + params.requiredLength + ' characters',
    pattern: (params:any) => 'Should be a valid ##FIELD## ',
    email: (params:any) => 'Invalid email *',
    vaildEmail: (params:any) => 'Invalid email',
    specialCharacter: (params:any) => 'No Special Characters are Allowed *',
    startsWith: (params:any) => '##FIELD## must start with ' + params.value,
    numberOnly: (params:any) => 'Only Numbers are allowed *',
    letterOnly: (params:any) => 'Only Letters are allowed *',
    min: (params:any) => '##FIELD## minimum character is ' + params.minValue,
    max: (params:any) => '##FIELD## maximum character is ' + params.maxValue,
    minDate: (params:any) => 'Date must be after the selected date',
    maxDate: (params:any) => 'Date must be before the selected date ',
    shouldBe: (params:any) => '##FIELD## must be ' + params.num + ' characters',
    shouldBeEqual: (params:any) => 'Confirm password must match password',
    confirmPassword: (params:any) => 'Passwords must match *',
    alphaDash: (params:any) => 'Enter valid name *',
    customMessage: (params:any) => params.value
  };

  formNames = {};

  @Input()
  control!: AbstractControlDirective | AbstractControl;
  @Input()
  label!: string;

  ngOnInit() {
  }

  shouldShowErrors(): null | boolean {
    return this.control && this.control.errors && (this.control.dirty || this.control.touched);
  }

  getError(): string {
    const errors = Object.keys(this.control.errors).map(field => this.getMessage(field, this.control.errors?.[field], this.control));
    return errors[0];
  }

  getControlName(c: AbstractControl): string | null {
    if(c.parent){
      const formGroup = c.parent.controls as { [key: string]: AbstractControl<any, any>; };
      return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
    }
    return null;
  }

  private getMessage(type: string, params: any, control: any) {
    let fname = this.getControlName(control);
    for (const init in this.formNames) {
      if (fname === init) {
        fname = this.formNames[fname];
      } else {
        fname = fname;
      }
    }

    const msg = FormErrorComponent.errorMessages[type](params);
    let fieldName = fname.replace(/([A-Z])/g, (match) => ` ${match}`)
      .replace(/^./, (match) => match.toUpperCase());
    fieldName = this.label ? this.label : fieldName;
    return msg.replace('##FIELD##', fieldName);
  }

}
